import { Injectable } from '@angular/core'
import { createStore, withProps } from '@ngneat/elf'
import { tap } from 'rxjs/operators'
import {
  Facet,
  FacetsGQL,
  FacetValueProductVariantCountGQL,
} from '../gql/generated'
import { LoaderService } from './loader.service'

interface FacetState {
  facets: Facet[]
  counts: Map<string, number>
}

const initialState: FacetState = {
  facets: [],
  counts: new Map<string, number>(),
}

@Injectable({
  providedIn: 'root',
})
export class FacetService {
  facetStore$ = createStore(
    { name: 'facets' },
    withProps<FacetState>(initialState)
  )

  constructor(
    private facetsGQL: FacetsGQL,
    private loaderService: LoaderService,
    private facetValueProductVariantCount: FacetValueProductVariantCountGQL
  ) {}

  fetchFacets() {
    return this.loaderService.withLoader(
      () =>
        this.facetsGQL.fetch(
          undefined,
          {
            context: {
              headers: {
                'vendure-token': 'K7',
              },
            },
            fetchPolicy: 'network-only',
          }
        ).pipe(
          tap({
            next: (response) => {
              const facets = response.data.facets.items.map(
                (facet) => facet as Facet
              )
              this.facetStore$.update((store) => ({
                ...store,
                facets,
              }))
            },
          })
        ),
      FacetService.name
    )
  }
}
